export default __webpack_public_path__ + "static/social-default-image-664a41a42de324dd804b78ac904b6a19.png";